/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { CertificateIcon } from '@coursera/cds-icons';

import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

import _t from 'i18n!nls/xdp';

const styles = {
  item: css`
    display: flex;
    gap: var(--cds-spacing-200);
  `,
  iconContainer: css`
    border-radius: 8px;
    background: var(--cds-color-neutral-background-primary-weak);
    display: flex;
    width: 76px;
    height: 54px;
    padding: calc(var(--cds-spacing-100) / 2);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  `,
  title: css`
    margin-bottom: var(--cds-spacing-100);
  `,
  titleRedesign: css`
    margin-bottom: var(--cds-spacing-50);
  `,
  description: css`
    max-width: 608px;
  `,
};

const CareerCertificateItem = () => {
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  return (
    <div css={styles.item}>
      <div css={styles.iconContainer}>
        <CertificateIcon size="large" color="interactive" width={34} height={34} />
      </div>
      <div>
        <Typography2
          component="h3"
          variant={enableXDPRedesign ? 'subtitleMedium' : 'subtitleLarge'}
          css={enableXDPRedesign ? styles.titleRedesign : styles.title}
        >
          {_t('Earn a career certificate')}
        </Typography2>
        <Typography2 component="p" variant="bodySecondary" css={styles.description}>
          {_t(
            'Add this credential to your LinkedIn profile, resume, or CV. Share it on social media and in your performance review.'
          )}
        </Typography2>
      </div>
    </div>
  );
};

export default CareerCertificateItem;
